import React from 'react';
import Icon from '@ant-design/icons/lib/components/Icon';
import SendButtonSvg from './SendButtonOutlined.svg';

// eslint-disable-next-line react/require-default-props
const SendButtonOutlined = function (props: React.ComponentProps<typeof Icon>) {
  return (
    <Icon component={SendButtonSvg} {...props} />
  );
};

export default SendButtonOutlined;
